import { useTranslation } from 'react-i18next';

import Header from '../../../styledComponents/PageDetails/HeaderPageDetails/HeaderPageDetails';
import { useSubscriptionKERenew } from './keSubscriptionRenewPage.hooks';
import FormErrorProvider from '../../../styledComponents/FormErrorProvider/FormErrorProvider';
import AddContractModal from '../../../styledComponents/Modals/AddContractModal/AddContractModal';
import Spinner from '../../../styledComponents/Spinner/Spinner';
import KESubscriptionRenewPageForm from './KESubscriptionRenewPageForm/KESubscriptionRenewPageForm';
import { ProductType } from '../../../models/ProductType';
import KESubscriptionAnalyseModal from './KESubscriptionAnalyseModal/KESubscriptionAnalyseModal';

export const KESubscriptionRenewPage = () => {
  const { t } = useTranslation();
  const {
    organization,
    isOrganizationDataLoading,
    isPricingDataLoading,
    isSuggestionDataLoading,
    loadSubscriptionRenewalSuggestionHandler,
    subscriptionRenewalSuggestion,
    loadDatesForNewSubscriptionHandler,
  } = useSubscriptionKERenew();

  if (
    !organization ||
    isOrganizationDataLoading ||
    !subscriptionRenewalSuggestion ||
    (!subscriptionRenewalSuggestion && isSuggestionDataLoading) ||
    isPricingDataLoading
  ) {
    return <Spinner />;
  }

  return (
    <>
      <AddContractModal />
      <KESubscriptionAnalyseModal
        onAnalyseSuccess={loadSubscriptionRenewalSuggestionHandler}
      />
      <FormErrorProvider>
        <>
          <Header
            title={t('headers.renew-subscription', {
              productType: ProductType.KidnapAndExtortion,
              organizationName: organization?.name,
            })}
          />
          <KESubscriptionRenewPageForm
            onContractChanged={loadDatesForNewSubscriptionHandler}
          />
        </>
      </FormErrorProvider>
    </>
  );
};
